import { useState, useCallback } from 'react';
import useDownloadPdf from '@shared/hooks/useDownloadPdf';

import signatureId from '@shared/helpers/signatureId';

const useDocsTableFeatures = (data, phone) => {
  const [selected, setSelected] = useState({});
  const { downloadMultiple, isDownloading } = useDownloadPdf();

  const downloadSelected = () => {
    downloadMultiple(Object.keys(selected));
  };

  const handleRowSelect = rowId => {
    const newSelected = { ...selected };
    if (rowId in selected) {
      delete newSelected[rowId];
    } else {
      newSelected[rowId] = true;
    }
    setSelected(newSelected);
  };

  const areAllSelected = () =>
    data?.signatures.every(item => signatureId(item) in selected) || false;

  const handleSelectAllClick = () => {
    const newSelected = { ...selected };

    if (areAllSelected()) {
      for (const signature of data?.signatures) {
        delete newSelected[signatureId(signature)];
      }
    } else {
      for (const signature of data?.signatures) {
        newSelected[signatureId(signature)] = true;
      }
    }
    setSelected(newSelected);
  };

  const onDownloadAll = useCallback(() => {
    console.error('Not implemented yet!');
  }, []);

  return {
    selected,
    isDownloading,
    handleRowSelect,
    handleSelectAllClick,
    onDownloadAll,
    downloadSelected,
    areAllSelected: areAllSelected(),
    setSelected,
  };
};

export default useDocsTableFeatures;
